import InviteUserToOrgObject from "api/lib/data/interfaces/InviteUserToOrgObject";
import Organizations from "api/lib/data/Organizations";
import * as Joi from "joi";
import * as React from "react";
import { Modal, Button, Message } from "semantic-ui-react";
import {
  Form,
  IInterfaceFormProps,
  IInterfaceFormState,
} from "src/components/Form";
import { toast } from "react-semantic-toasts";
import ReactChipInput from "react-chip-input";

interface IInviteUserModelProps extends IInterfaceFormProps {
  authUser: any;
  currentOrg: any;
  open: boolean;
  setOpen: (open: boolean) => void;
}

interface IInterfaceState extends IInterfaceFormState {
  error: any;
}

export class InviteUserModel extends Form<
  IInviteUserModelProps,
  IInterfaceState
> {
  private static INITIAL_STATE = {
    data: {
      emails: [],
    },
    error: null,
    errors: {},
  };

  private static schema: Joi.SchemaLike = {
    emails: Joi.array()
      .items(Joi.string().email())
      .min(1)
      .required()
      .label("Emails"),
  };

  private static emailValidationSchema: Joi.SchemaLike = {
    email: Joi.string().email().required(),
  };
  private static propKey(propertyName: string, value: any): object {
    return { [propertyName]: value };
  }

  constructor(props: IInviteUserModelProps) {
    super(props, InviteUserModel.schema);
    this.state = {
      ...Form.FORM_INITAL_STATE,
      ...InviteUserModel.INITIAL_STATE,
    };
  }

  addChip = (value: string) => {
    this.setState({ error: null });
    const { error } = Joi.validate(
      { email: value },
      InviteUserModel.emailValidationSchema
    );

    if (!error) {
      const emails = this.state.data.emails.slice();
      emails.push(value);
      this.setState({ data: { emails } });
    } else {
      this.setState(InviteUserModel.propKey("error", error));
    }
  };
  removeChip = (index: number) => {
    const emails = this.state.data.emails.slice();
    emails.splice(index, 1);
    this.setState({ data: { emails } });
  };
  public render() {
    const { open, setOpen, currentOrg } = this.props;
    const { error } = this.state;

    return (
      <Modal
        size="small"
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
      >
        <Modal.Header>Invite people to {currentOrg.name}</Modal.Header>

        <Modal.Content>
          <ReactChipInput
            chips={this.state.data.emails}
            onRemove={(index: number) => this.removeChip(index)}
            onSubmit={(value: string) => this.addChip(value)}
            classes={"invite_people_chips"}
          />
          {error && <Message error={true} header={"Not a valid email"} />}
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          {this.renderSubmitButton("Create")}
        </Modal.Actions>
      </Modal>
    );
  }
  protected doSubmit(callback: () => void) {
    const { emails } = this.state.data;
    const { currentOrg, authUser } = this.props;
    const org = new Organizations();
    const inviteUserReq: InviteUserToOrgObject = {
      audit: {
        createdBy: authUser.uid,
      },
      request: {
        audit: {
          createdBy: authUser.uid,
        },
        emails,
      },
    };
    org
      .invitePeople(currentOrg.id, authUser.uid, inviteUserReq)
      .then(() => {
        this.setState(() => ({ ...InviteUserModel.INITIAL_STATE }));
        toast({
          type: "success",
          icon: "info circle",
          title: `Invitation(s) sent successfully `,
          animation: "slide up",
          time: 5000,
        });
        this.props.setOpen(false);
        callback();
      })
      .catch((error) => {
        callback();
        this.setState(InviteUserModel.propKey("error", error));
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/Organizations/InviteUsersModel.tsx